import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';


const JobsAndProvidersSection = () => {
  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [isJobDialogOpen, setIsJobDialogOpen] = useState(false);
  const [isProviderDialogOpen, setIsProviderDialogOpen] = useState(false);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const [viewMode, setViewMode] = useState('card'); // 'card' or 'list'
  const [applicationData, setApplicationData] = useState({
    fullName: '',
    email: '',
    phone: '',
    coverLetter: '',
    experience: ''
  });

  const featuredJobs = [
  {
    id: 1,
    title: 'Residential Plumbing Repair',
    category: 'Plumbing',
    description: 'Need experienced plumber to fix leaking pipes and install new fixtures in bathroom.',
    location: 'Quezon City',
    budgetMin: 2500,
    budgetMax: 4000,
    postedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    urgency: 'urgent',
    applicantCount: 12,
    isVerified: true,
    clientInfo: {
      name: 'Roberto Martinez',
      memberSince: '2024',
      jobsPosted: 8,
      rating: 4.7,
      verified: true
    },
    requirements: [
    'Minimum 3 years of plumbing experience',
    'Valid plumbing license or certification',
    'Own tools and equipment',
    'Available for emergency repairs',
    'References from previous clients'],

    projectDuration: '1-2 days',
    startDate: 'ASAP'
  },
  {
    id: 2,
    title: 'Home Electrical Wiring',
    category: 'Electrical',
    description: 'Looking for licensed electrician to rewire living room and install new outlets.',
    location: 'Manila',
    budgetMin: 5000,
    budgetMax: 8000,
    postedDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    urgency: 'high',
    applicantCount: 8,
    isVerified: true,
    clientInfo: {
      name: 'Ana Reyes',
      memberSince: '2023',
      jobsPosted: 15,
      rating: 4.9,
      verified: true
    },
    requirements: [
    'Licensed electrician with valid certification',
    'Experience with residential wiring',
    'Knowledge of electrical codes and safety standards',
    'Provide warranty for work completed',
    'Insurance coverage required'],

    projectDuration: '3-4 days',
    startDate: 'Within 1 week'
  },
  {
    id: 3,
    title: 'Custom Kitchen Cabinets',
    category: 'Carpentry',
    description: 'Seeking skilled carpenter to build custom kitchen cabinets with modern design.',
    location: 'Makati',
    budgetMin: 15000,
    budgetMax: 25000,
    postedDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    urgency: 'normal',
    applicantCount: 15,
    isVerified: true,
    clientInfo: {
      name: 'Carlos Tan',
      memberSince: '2025',
      jobsPosted: 3,
      rating: 5.0,
      verified: true
    },
    requirements: [
    'Portfolio of previous cabinet work',
    'Experience with modern kitchen designs',
    'Ability to read and work from design plans',
    'Own carpentry tools',
    'Provide material recommendations'],

    projectDuration: '2-3 weeks',
    startDate: 'Flexible'
  },
  {
    id: 4,
    title: 'Deep House Cleaning',
    category: 'Cleaning',
    description: 'Need professional cleaning service for 3-bedroom house, including windows and carpets.',
    location: 'Pasig',
    budgetMin: 3000,
    budgetMax: 5000,
    postedDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
    urgency: 'normal',
    applicantCount: 20,
    isVerified: false,
    clientInfo: {
      name: 'Lisa Garcia',
      memberSince: '2025',
      jobsPosted: 2,
      rating: 4.5,
      verified: false
    },
    requirements: [
    'Professional cleaning experience',
    'Bring own cleaning supplies and equipment',
    'Attention to detail',
    'Reliable and punctual',
    'Background check preferred'],

    projectDuration: '1 day',
    startDate: 'This weekend'
  },
  {
    id: 5,
    title: 'Weekend Babysitting',
    category: 'Babysitting',
    description: 'Looking for reliable babysitter for 2 kids (ages 3 and 5) on weekends.',
    location: 'Taguig',
    budgetMin: 500,
    budgetMax: 800,
    postedDate: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
    urgency: 'normal',
    applicantCount: 18,
    isVerified: true,
    clientInfo: {
      name: 'Michelle Cruz',
      memberSince: '2024',
      jobsPosted: 12,
      rating: 4.8,
      verified: true
    },
    requirements: [
    'Experience with toddlers and young children',
    'First aid and CPR certified',
    'Patient and energetic personality',
    'References from previous families',
    'Background check required'],

    projectDuration: 'Ongoing (Saturdays)',
    startDate: 'Next Saturday'
  }];



  const serviceProviders = [
  {
    id: 1,
    name: 'Juan Dela Cruz',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1766c5fee-1768139783060.png",
    imageAlt: 'Filipino male plumber in blue work uniform holding wrench standing in front of white wall with confident smile',
    category: 'Plumbing',
    rating: 4.9,
    reviews: 156,
    hourlyRate: 350,
    skills: ['Pipe Repair', 'Installation', 'Maintenance'],
    verified: true,
    completedJobs: 234,
    location: 'Quezon City'
  },
  {
    id: 2,
    name: 'Maria Santos',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b110b4b6-1766961752778.png",
    imageAlt: 'Filipino female electrician in yellow safety vest and hard hat holding electrical tools with professional demeanor',
    category: 'Electrical',
    rating: 4.8,
    reviews: 142,
    hourlyRate: 400,
    skills: ['Wiring', 'Circuit Repair', 'Installation'],
    verified: true,
    completedJobs: 198,
    location: 'Manila'
  },
  {
    id: 3,
    name: 'Pedro Reyes',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11114b8a3-1767440385559.png",
    imageAlt: 'Filipino male carpenter in brown apron holding wooden plank in workshop with tools in background',
    category: 'Carpentry',
    rating: 4.9,
    reviews: 178,
    hourlyRate: 380,
    skills: ['Furniture Making', 'Repairs', 'Custom Work'],
    verified: true,
    completedJobs: 267,
    location: 'Makati'
  },
  {
    id: 4,
    name: 'Ana Garcia',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_134d0fea5-1768259192462.png",
    imageAlt: 'Filipino female cleaner in white uniform with cleaning supplies and bright smile in modern home setting',
    category: 'Cleaning',
    rating: 5.0,
    reviews: 203,
    hourlyRate: 250,
    skills: ['Deep Cleaning', 'House Maintenance', 'Organization'],
    verified: true,
    completedJobs: 412,
    location: 'Pasig'
  },
  {
    id: 5,
    name: 'Rosa Mendoza',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_166cbf822-1768294705002.png",
    imageAlt: 'Filipino female nanny in casual pink shirt playing with children in bright living room with toys',
    category: 'Babysitting',
    rating: 4.9,
    reviews: 167,
    hourlyRate: 200,
    skills: ['Childcare', 'Early Education', 'First Aid'],
    verified: true,
    completedJobs: 289,
    location: 'Taguig'
  }];



  const getCategoryIcon = (category) => {
    const icons = {
      'Plumbing': 'Wrench',
      'Electrical': 'Zap',
      'Carpentry': 'Hammer',
      'Cleaning': 'Sparkles',
      'Babysitting': 'Baby',
      'Tutoring': 'GraduationCap'
    };
    return icons?.[category] || 'Briefcase';
  };

  const getUrgencyColor = (urgency) => {
    switch (urgency) {
      case 'urgent':
        return 'bg-error/10 text-error border-error/20';
      case 'high':
        return 'bg-warning/10 text-warning border-warning/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const formatDate = (date) => {
    const now = new Date();
    const jobDate = new Date(date);
    const diffTime = Math.abs(now - jobDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Yesterday';
    if (diffDays < 7) return `${diffDays} days ago`;
    return jobDate?.toLocaleDateString('en-PH', { day: '2d', month: '2d', year: 'numeric' });
  };

  const handleJobClick = (job) => {
    setSelectedJob(job);
    setIsJobDialogOpen(true);
    setShowApplicationForm(false);
    setApplicationData({
      fullName: '',
      email: '',
      phone: '',
      coverLetter: '',
      experience: ''
    });
  };

  const handleProviderClick = (provider) => {
    setSelectedProvider(provider);
    setIsProviderDialogOpen(true);
  };

  const handleApply = (job) => {
    setShowApplicationForm(true);
  };

  const handleContact = (provider) => {
    navigate('/messages', { state: { recipientId: provider?.id, recipientName: provider?.name } });
  };

  const handleApplicationSubmit = (e) => {
    e?.preventDefault();
    console.log('Application submitted:', { job: selectedJob, application: applicationData });
    alert('Application submitted successfully!');
    setIsJobDialogOpen(false);
    setShowApplicationForm(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setApplicationData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className="py-8 md:py-10 lg:py-12 bg-white relative overflow-hidden">
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        
        {/* Featured Jobs Section */}
        <div className="mb-12">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-2">
                Featured Jobs
              </h2>
              <p className="text-xs md:text-sm text-muted-foreground">
                Latest job opportunities waiting for you
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setViewMode('card')}
                className={`p-2 rounded-lg transition-colors ${
                  viewMode === 'card' ? 'bg-[#FF6A00] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <Icon name="LayoutGrid" size={18} />
              </button>
              <button
                onClick={() => setViewMode('list')}
                className={`p-2 rounded-lg transition-colors ${
                  viewMode === 'list' ? 'bg-[#FF6A00] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <Icon name="List" size={18} />
              </button>
            </div>
          </div>

          {/* Card View */}
          {viewMode === 'card' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {featuredJobs?.map((job) => (
                <div
                  key={job?.id}
                  onClick={() => {
                    setSelectedJob(job);
                    setIsJobDialogOpen(true);
                  }}
                  className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100 hover:border-[#FF6A00]"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <h3 className="text-sm font-semibold text-foreground mb-1">
                        {job?.title}
                      </h3>
                      <div className="flex items-center gap-2 text-xs text-muted-foreground">
                        <Icon name="MapPin" size={12} />
                        <span>{job?.location}</span>
                      </div>
                    </div>
                    {job?.isVerified && (
                      <div className="w-5 h-5 bg-[#FF6A00] rounded-full flex items-center justify-center">
                        <Icon name="Check" size={12} color="white" />
                      </div>
                    )}
                  </div>
                  <p className="text-xs text-muted-foreground mb-3 line-clamp-2">
                    {job?.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-semibold text-[#1E73BE]">
                      ₱{job?.budgetMin?.toLocaleString()} - ₱{job?.budgetMax?.toLocaleString()}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {job?.applicantCount} applicants
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* List View */}
          {viewMode === 'list' && (
            <div className="space-y-3">
              {featuredJobs?.map((job) => (
                <div
                  key={job?.id}
                  onClick={() => {
                    setSelectedJob(job);
                    setIsJobDialogOpen(true);
                  }}
                  className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100 hover:border-[#FF6A00] flex items-center gap-4"
                >
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-2">
                      <h3 className="text-sm font-semibold text-foreground">
                        {job?.title}
                      </h3>
                      {job?.isVerified && (
                        <div className="w-5 h-5 bg-[#FF6A00] rounded-full flex items-center justify-center">
                          <Icon name="Check" size={12} color="white" />
                        </div>
                      )}
                    </div>
                    <p className="text-xs text-muted-foreground mb-2 line-clamp-1">
                      {job?.description}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <div className="flex items-center gap-1">
                        <Icon name="MapPin" size={12} />
                        <span>{job?.location}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Icon name="Users" size={12} />
                        <span>{job?.applicantCount} applicants</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-sm font-semibold text-[#1E73BE] whitespace-nowrap">
                    ₱{job?.budgetMin?.toLocaleString()} - ₱{job?.budgetMax?.toLocaleString()}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Featured Service Providers Section - Separate with Ample Spacing */}
        <div className="pt-8 border-t-2 border-gray-200">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground mb-2">
                Featured Service Providers
              </h2>
              <p className="text-xs md:text-sm text-muted-foreground">
                Top-rated professionals ready to help
              </p>
            </div>
          </div>

          {/* Card View */}
          {viewMode === 'card' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {serviceProviders?.map((provider) => (
                <div
                  key={provider?.id}
                  onClick={() => {
                    setSelectedProvider(provider);
                    setIsProviderDialogOpen(true);
                  }}
                  className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100 hover:border-[#FF6A00] flex items-center gap-4"
                >
                  <div className="relative w-16 h-16 flex-shrink-0">
                    <Image
                      src={provider?.image}
                      alt={provider?.imageAlt}
                      className="w-full h-full object-cover rounded-lg"
                    />
                    {provider?.verified && (
                      <div className="absolute -top-1 -right-1 w-5 h-5 bg-[#FF6A00] rounded-full flex items-center justify-center">
                        <Icon name="Check" size={10} color="white" />
                      </div>
                    )}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm font-semibold text-foreground mb-1">
                      {provider?.name}
                    </h3>
                    <div className="flex items-center gap-2 mb-2">
                      <div className="flex items-center gap-1">
                        <Icon name="Star" size={12} color="#FF6A00" />
                        <span className="text-xs font-semibold">{provider?.rating}</span>
                      </div>
                      <span className="text-xs text-muted-foreground">
                        ({provider?.reviews} reviews)
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <Icon name="MapPin" size={12} />
                      <span>{provider?.location}</span>
                    </div>
                  </div>
                  <div className="text-sm font-semibold text-[#1E73BE]">
                    ₱{provider?.hourlyRate}/hr
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* List View */}
          {viewMode === 'list' && (
            <div className="space-y-3">
              {serviceProviders?.map((provider) => (
                <div
                  key={provider?.id}
                  onClick={() => {
                    setSelectedProvider(provider);
                    setIsProviderDialogOpen(true);
                  }}
                  className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100 hover:border-[#FF6A00] flex items-center gap-4"
                >
                  <div className="relative w-12 h-12 flex-shrink-0">
                    <Image
                      src={provider?.image}
                      alt={provider?.imageAlt}
                      className="w-full h-full object-cover rounded-lg"
                    />
                    {provider?.verified && (
                      <div className="absolute -top-1 -right-1 w-4 h-4 bg-[#FF6A00] rounded-full flex items-center justify-center">
                        <Icon name="Check" size={8} color="white" />
                      </div>
                    )}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm font-semibold text-foreground mb-1">
                      {provider?.name}
                    </h3>
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <div className="flex items-center gap-1">
                        <Icon name="Star" size={12} color="#FF6A00" />
                        <span className="font-semibold">{provider?.rating}</span>
                        <span>({provider?.reviews})</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Icon name="MapPin" size={12} />
                        <span>{provider?.location}</span>
                      </div>
                      <div className="flex items-center gap-1">
                        <Icon name="Briefcase" size={12} />
                        <span>{provider?.completedJobs} jobs</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-sm font-semibold text-[#1E73BE] whitespace-nowrap">
                    ₱{provider?.hourlyRate}/hr
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default JobsAndProvidersSection;